/** Alternate theme: cool slate/blue palette, Inter font, centered login. */
export default {
  id: 'ardoise',
  label: 'Ardoise',
  colors: {
    light: { primary: '#2563eb', secondary: '#0f172a' },
    dark: { primary: '#60a5fa', secondary: '#94a3b8' },
    tokens: {
      light: { loginInfoBg: '#EEF2F7', assistantBubbleBg: '#EEF2FF', thinkingDot: '#2563eb', accountIcon: '#2563eb' },
      dark: { loginInfoBg: '#EEF2F7', assistantBubbleBg: '#EEF2FF', thinkingDot: '#2563eb', accountIcon: '#60a5fa' },
    },
  },
  fonts: {
    family: "'Inter', sans-serif",
    stylesheet: 'https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap',
  },
  layout: { loginLayout: 'centered', borderRadius: 10 },
}
